<template>
  <div>
    <div class="w-full py-4 px-4 text-gray-900 text-left capitalize font-medium">
      <router-link
        to="/"
      >
        <img
          src="https://s3-eu-central-1.amazonaws.com/neticle-images/2019/10/textapi_256-1.png"
          alt="alt neticle-text-analysis-api"
          class="w-8 h-8 mx-auto mb-5"
        >
      </router-link>
      <router-link
        to="/overview"
        class="cursor-pointer hover:bg-gray-200 hover:text-gray-700 rounded mb-1 flex items-center"
      >
        <fa-icon
          :icon="['fal', 'tachometer']"
          class="w-16 mx-2"
        />
        <span class="mx-1 text-sm">{{ $t("Overview menu item", "Overview") }}</span>
      </router-link>
      <router-link
        to="/Projects"
        class="cursor-pointer hover:bg-gray-200 hover:text-gray-700 rounded mb-1 flex items-center"
      >
        <fa-icon
          :icon="['fal', 'key']"
          class="w-16 mx-2"
        />
        <span class="mx-1 text-sm">{{ $t("Keys menu item", "Projects") }}</span>
      </router-link>
      <router-link
        to="/sentiment-rules"
        class="cursor-pointer hover:bg-gray-200 hover:text-gray-700 rounded mb-1 flex items-center"
      >
        <fa-icon
          :icon="['fal', 'comment-plus']"
          class="w-16 mx-2"
        />
        <span class="mx-1 text-sm">{{ $t("Sentiment rules menu item", "Sentiment rules") }}</span>
      </router-link>
      <router-link
        to="/custom-labels"
        class="cursor-pointer hover:bg-gray-200 hover:text-gray-700 rounded mb-1 flex items-center"
      >
        <fa-icon
          :icon="['fal', 'tag']"
          class="w-16 mx-2"
        />
        <span class="mx-1 text-sm">{{ $t("Custom labels menu item", "Custom labels") }}</span>
      </router-link>
      <router-link
        to="/settings"
        class="cursor-pointer hover:bg-gray-200 hover:text-gray-700 rounded mb-1 flex items-center"
      >
        <fa-icon
          :icon="['fal', 'cog']"
          class="w-16 mx-2"
        />
        <span class="mx-1 text-sm">{{ $t("Settings menu item", "Settings") }}</span>
      </router-link>
      <router-link
        v-if="isAdmin"
        to="/admin"
        class="cursor-pointer hover:bg-gray-200 hover:text-gray-700 rounded mb-1 flex items-center"
      >
        <fa-icon
          :icon="['fal', 'shield-alt']"
          class="w-16 mx-2"
        />
        <span class="mx-1 text-sm">{{ $t("Admin menu item", "Admin") }}</span>
      </router-link>
      <span
        class="cursor-pointer hover:bg-gray-200 hover:text-gray-700 rounded mb-1 flex items-center"
        @click="logout"
      >
        <fa-icon
          :icon="['fal', 'sign-out']"
          class="w-16 mx-2"
        />
        <span class="mx-1 text-sm">
          {{ $t("Sign Out menu item", "Sign Out") }}
        </span>
      </span>
      <div class="fixed bottom-0 mb-4 flex items-center left-0">
        <fa-icon
          :icon="['fal', 'user-circle']"
          class="w-16 mx-2"
        />
        <span class="mx-1 text-sm block w-2/3">
          <div class="font-bold">
            {{ name }}
          </div>
          <div>
            {{ subscription.name }}
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { actionNames } from '@/store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSignOut, faShieldAlt, faCog, faKey, faTag, faTachometer, faCommentPlus, faUserCircle } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapState } from 'vuex'
library.add(faSignOut, faTachometer, faKey, faShieldAlt, faCog, faTag, faCommentPlus, faUserCircle)
export default {
  name: 'NavBar',
  components: {
    'fa-icon': FontAwesomeIcon
  },
  computed: {
    ...mapState({
      subscription: state => state.auth.subscription,
      name: state => state.auth.name
    }),
    isAdmin () {
      return this.$store.getters.isAdmin
    }
  },
  mounted () {
    this.$store.dispatch(actionNames.INIT_GROUP_DATA)
  },
  methods: {
    logout () {
      this.$store.dispatch(actionNames.LOGOUT)
    }
  }
}
</script>
